import { vehiclesConstants } from '../_constants/vehicles.constants'

const INITIAL_STATE = {
  allVehicles: null,
  availables: null,
}

const vehiclesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case vehiclesConstants.GET_VEHICLES:
      return {
        ...state,
        allVehicles: action.payload,
      }

    case vehiclesConstants.GET_VEHICLES_AVAILABLES:
      return {
        ...state,
        availables: action.payload,
      }

    default:
      return state
  }
}

export default vehiclesReducer
